import { RANK } from './columnConfig';
import { ASCENDING_ORDER } from 'components/common/table/constants';

export const tableConfig = {
  pagination: false,
  initialSort: [{ column: RANK, dir: ASCENDING_ORDER }],
};
